import { component } from 'picoapp';
import { getCart } from 'utils/cart';
import Drawer from 'utils/drawer';

export default component((node, ctx) => {
  const trigger = node.querySelector('[data-trigger]');
  const drawerTarget = trigger.dataset.trigger;

  const form = document.querySelector(`[data-drawer="${drawerTarget}"]`);
  const attachOverlay = form.parentNode;
  const drawer = Drawer(form, attachOverlay);

  trigger.addEventListener('click', (e) => {
    e.preventDefault();
    drawer.open();
  });

  const submit = async (event) => {
    event.preventDefault();

    ctx.emit('cart:updating');
    const formData = new FormData(form);

    const response = await fetch(`${form.action}.js`, {
      method: form.method,
      body: formData,
    });

    const cartData = await getCart();

    drawer.close();
    ctx.emit('cart:updated', ({ cart: cartData }));

    document.dispatchEvent(new CustomEvent('product:added', {
      detail: { data: response },
    }));
  };

  form.addEventListener('submit', submit);
});
